module.exports = __webpack_public_path__ + "static/media/SFST_1-950w.aee3c1a0.webp";